import { render, staticRenderFns } from "./App.vue?vue&type=template&id=53f7baf0&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=53f7baf0&prod&scoped=true&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=53f7baf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7baf0",
  null
  
)

export default component.exports